import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-foam-box',
  templateUrl: './foam-box.component.html',
  styleUrls: ['./foam-box.component.css']
})
export class FoamBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
